/* eslint-disable import/no-anonymous-default-export */
export default (investmentType = [], action) => {
  switch (action.type) {
    case "GET_INVESTMENT_TYPE":
      return action.payload;
    case "CREATE_INVESTMENT_TYPE":
      return [...investmentType, action.payload];
    case "NEW_INVESTMENT_TYPE_TO_BE_DELETED":
      return investmentType.filter((data) => data._id !== action.payload);
    default:
      return investmentType;
  }
};
